import { DatePicker } from '@clockwise/ui';

interface Props {
  asOf: string;
  onAsOfChange: (value: string) => void;
  showAll: boolean;
  onShowAllChange: (value: boolean) => void;
  /** Checkbox label — the panels don't agree on what "all" means (past
   *  budgets, ended expenses, ended memberships), so this stays a prop rather
   *  than one shared string. */
  showAllLabel: string;
  /** Sentence explaining the current scope, e.g. "Showing what is billed
   *  today." Also panel-specific copy. */
  statusText: string;
}

/**
 * As-of filter + "show all" toggle + a sentence stating current scope,
 * for a customer sub-resource panel (budgets / expenses / team). Renders as
 * sibling elements, not a wrapping container — drop it inside the panel's own
 * toolbar `<div className="flex flex-wrap items-center gap-3">` alongside
 * whatever else that panel's toolbar needs (search box, Add button).
 */
export function AsOfFilterToggle({
  asOf,
  onAsOfChange,
  showAll,
  onShowAllChange,
  showAllLabel,
  statusText,
}: Props): React.ReactElement {
  return (
    <>
      {!showAll ? (
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground">As of</span>
          <DatePicker
            value={asOf}
            onChange={onAsOfChange}
            placeholder="Today"
            clearable
            asOf
            className="w-44"
          />
        </div>
      ) : null}
      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          className="size-4 rounded border-input"
          checked={showAll}
          onChange={(e) => onShowAllChange(e.target.checked)}
        />
        <span>{showAllLabel}</span>
      </label>
      <p className="text-xs text-muted-foreground">{statusText}</p>
    </>
  );
}
